﻿export default class SimpleTabs {

	private activeCSSClass = 'is-active';

	constructor() {
		this.attachTabTriggerClick();
	}

	private attachTabTriggerClick() {

		const triggerElements = document.querySelectorAll('[data-tab-target]');

		for (let i = 0, len = triggerElements.length; i < len; i++) {

			triggerElements[i].addEventListener('click', (e) => {
				const currentTrigger = e.target as HTMLButtonElement;
				const target = document.querySelector(currentTrigger.getAttribute('data-tab-target'));
				this.closeOtherTabs();
				currentTrigger.classList.add(this.activeCSSClass);
				target.classList.add(this.activeCSSClass);
				target.setAttribute('aria-hidden', 'false');
			});

		}

	}

	private closeOtherTabs() {
		this.closeTabTriggers();
		this.closeTabContent();
	}

	private closeTabTriggers() {
		const tabElements = document.querySelectorAll('[data-tab-target]');
		for (let i = 0, len = tabElements.length; i < len; i++) {
			tabElements[i].classList.remove(this.activeCSSClass);
		}
	}

	private closeTabContent() {
		const tabContents = document.querySelectorAll('[data-tab-content]');
		for (let i = 0, len = tabContents.length; i < len; i++) {
			tabContents[i].classList.remove(this.activeCSSClass);
			tabContents[i].setAttribute('aria-hidden', 'true');
		}
	}

}
